<template>
    <nav class="navbar shadow fixed top-0 bg-slate-50 left-0 w-full z-50">
    <div v-if="this.$route.path != '/' && this.$route.path != '/OpenBanks' " class=" w-10 h-10" @click="backButton">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
    </div>

    <div class="flex-1">
        <div v-if="this.$route.path != '/' && this.$route.path != '/OpenBanks' " class=" mx-auto">
            
            <router-link v-if="isLoggedIn" class=" w-7 h-6 relative " to="/OpenBanks">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="black" class="w-7 h-6 ">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                </svg>
                <img alt="Vue logo" src="../../../assets/logo.png" class=" w-3 h-3 absolute bottom-1 right-2">
            </router-link>

            <router-link v-else class=" w-7 h-6 relative" to="/">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="gray" class="w-7 h-6 ">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
                </svg>
                <img alt="Vue logo" src="../../../assets/logo.png" class=" w-3 h-3 absolute bottom-1 right-2">
            </router-link>
                
           
        </div>
    </div>
    <div class="flex-none gap-1">

        <!-- <div class="dropdown dropdown-bottom dropdown-end">
          <div tabindex="0" role="button" class="btn m-1">Click ⬇️</div>
          <ul tabindex="-1" class="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm">
            <li><a>Item 1</a></li>
            <li><a>Item 2</a></li>
          </ul>
        </div> -->
        
        <div class="dropdown dropdown-bottom dropdown-end">
            <label tabindex="0" role="button" class="btn btn-ghost btn-primary btn-circle avatar">

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>

            </label>
            <ul tabindex="-1" class="dropdown-content menu mt-2 p-2 shadow bg-base-100 w-32 space-y-2">
                
                <li v-if="isLoggedIn"> <router-link onclick="document.activeElement.blur();" class="" to="/BankStatus">My Account</router-link> </li>
               
                <li v-if="isLoggedIn"> <div v-on:click="logout()" onclick="document.activeElement.blur();">Logout</div> </li>
                
                <li v-if="!isLoggedIn">
                    <router-link class=" mx-2" to="/login" onclick="document.activeElement.blur();">Login</router-link>
                </li>
                <li v-if="!isLoggedIn">
                    <router-link class=" mx-2" to="/SignUp" onclick="document.activeElement.blur();">Sign Up</router-link>
                </li>
                
            </ul>
        </div>
    </div>
</nav>
</template>

<script>

export default{

    props:{
        isLoggedIn: Boolean
    },

    data(){
        return{
            // IsLoggedIn: false,
            username:''
        }
    },
    methods:{
        logout(){
            localStorage.removeItem('account')
            this.$parent.IsLoggedIn = false;
            this.$parent.logout();
            const redirectPath = this.$route.query.redirect || '/'
            this.$router.push(redirectPath)

        },
        backButton(){
            this.$router.back()
        }

    },
    mounted(){
        this.IsLoggedIn = this.$parent.IsLoggedIn;
    }
}


</script>